import React from 'react';
import { IonContent, IonPage, IonIcon, IonText } from '@ionic/react';
import { hammerOutline, constructOutline } from 'ionicons/icons';

const Maintenance = () => {
    return (
        <IonPage>
            <IonContent className="ion-padding ion-text-center flex items-center justify-center h-full">
                <div className="flex flex-col items-center justify-center h-full space-y-6 max-w-md mx-auto">
                    <div className="bg-yellow-50 p-6 rounded-full">
                        <IonIcon icon={constructOutline} style={{ fontSize: '64px', color: '#f59e0b' }} />
                    </div>
                    <h1 className="text-3xl font-bold text-gray-800">Site Maintenance</h1>
                    <p className="text-gray-600">
                        We are currently performing scheduled maintenance to improve our services. 
                        Please check back shortly. We apologize for the inconvenience.
                    </p>
                    <div className="pt-4">
                        <IonText color="medium">
                            <small>&copy; {new Date().getFullYear()} PeopPoll. All rights reserved.</small>
                        </IonText>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Maintenance;
